import { computed, observable, makeObservable } from 'mobx';

import { createModelSchema, list, primitive, custom, object } from 'serializr';
import { TaskConstraint } from '@vromo/models';
import { Geozone, GeozoneType } from '@vromo/models';

import { Coords } from '@vromo/models';
import { Campaign } from '@vromo/models';
import { Policy } from '@vromo/models';
import { Group } from '@vromo/models';

export class ZoneBlueprint {
    name: string | null = null;
    address: string | null = null;
    coords?: Coords;
    type: GeozoneType;
    radius: number;

    constructor() {
        makeObservable(this, {
            name: observable,
            address: observable,
            coords: observable,
            type: observable,
            radius: observable
        });
    }
}

createModelSchema(ZoneBlueprint, {
    name: primitive(),
    address: primitive(),
    coords: object(Coords),
    type: primitive(),
    radius: primitive()
});
export class TaskBlueprint {
    offset: number | null = null;
    source: number | null = null;
    timeframe: 'source' | 'mask' = 'mask';
    constraints: Set<TaskConstraint> = new Set();
    zone: ZoneBlueprint = {} as ZoneBlueprint;

    constructor() {
        makeObservable(this, {
            offset: observable,
            source: observable,
            timeframe: observable,
            constraints: observable,
            zone: observable
        });
    }
}

createModelSchema(TaskBlueprint, {
    offset: primitive(),
    source: primitive(),
    timeframe: primitive(),
    constraints: custom(
        (val: Set<TaskConstraint>) => Array.from(val),
        (val: Array<TaskConstraint>) => new Set(val)
    ),
    zone: object(ZoneBlueprint)
});

export class JobBlueprint {
    campaign: Campaign | null = null;
    policy: Policy | null = null;
    group: Group | null = null;
    name: string;

    tasks: Array<TaskBlueprint>;

    constructor() {
        makeObservable(this, {
            campaign: observable,
            policy: observable,
            group: observable,
            name: observable,
            tasks: observable
        });
    }
}

createModelSchema(JobBlueprint, {
    campaign: object(Campaign),
    policy: object(Policy),
    group: object(Group),
    name: primitive(),

    tasks: list(object(TaskBlueprint))
});

export class Blueprint {
    id?: number;
    created?: number;
    name: string;
    group: number | null = null;

    template: JobBlueprint;

    constructor() {
        makeObservable(this, {
            id: observable,
            created: observable,
            name: observable,
            group: observable,
            template: observable
        });
    }
}

createModelSchema(Blueprint, {
    id: primitive(),
    created: primitive(),
    name: primitive(),
    group: primitive(),

    template: object(JobBlueprint)
});
